import { Typography } from '@material-tailwind/react';
import { Navigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { getFreeTrialContext } from '../../../../api/utils/free-trial/api';
import { useAppDispatch } from '../../../../store/hook';
import { openAlert } from '../../../../store/features/modalSlice';
import { getErrorMessages } from '../../../../api/utils/util-func';
import { FreeTrialContextItem } from '../../../../constants/types/free-trial/type';
import FreeTrialPromotionBar from '../../../../components/free-trial/FreeTrialPromotionBar';
import FreeTrialHeader from '../../../../components/free-trial/FreeTrialHeader';
import FreeTrialHero from '../../../../components/free-trial/FreeTrialHero';
import FreeTrialInfoSection from '../../../../components/free-trial/FreeTrialInfoSection';
import FreeTrialExperienceSection from '../../../../components/free-trial/FreeTrialExperienceSection';

const FreeTrialLesson = () => {
  const dispatch = useAppDispatch();

  const linkToken = sessionStorage.getItem('freeTrialLinkToken');

  const [freeTrialContext, setFreeTrialContext] =
    useState<FreeTrialContextItem | null>(null);

  useEffect(() => {
    if (!linkToken) return;

    const fetchFreeTrialContext = async () => {
      try {
        const data = await getFreeTrialContext(linkToken);

        setFreeTrialContext(data);
      } catch (error) {
        dispatch(openAlert({ message: getErrorMessages(error) }));
      }
    };

    void fetchFreeTrialContext();
  }, [linkToken]);

  if (!linkToken) {
    return <Navigate to="/" replace />;
  }

  if (!freeTrialContext) {
    return (
      <div className="flex min-h-[calc(100dvh-58px)] items-center justify-center">
        <Typography className="text-sm text-gray-900">
          무료체험 정보를 불러오고 있어요.
        </Typography>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#F8F7FC]">
      <FreeTrialPromotionBar freeTrialContext={freeTrialContext} />

      <FreeTrialHeader />

      <main className="mx-auto max-w-[1180px] px-4 py-8 md:px-6 md:py-12">
        <FreeTrialHero freeTrialContext={freeTrialContext} />

        <FreeTrialExperienceSection freeTrialContext={freeTrialContext} />

        <FreeTrialInfoSection />
      </main>
    </div>
  );
};

export default FreeTrialLesson;
